import { useState, useEffect } from "react";
import { Modal, message } from 'antd';

import { url, header } from "../Constent/Constant";

function LocalDistanceMovingTips() {
  const [LongDistanceMovingTipsData, setLongDistanceMovingTipsData] = useState('')
  const [HeadingUpdate, setHeadingUpdate] = useState('')
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [ParaModalVisible, setParaModalVisible] = useState(false);
  const [UpdateId, setUpdateId] = useState('')

  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/headandpara/viewheadandpara`)
      .then(res => res.json())
      .then(data => {
        console.log("Tips Data", data)
        setLongDistanceMovingTipsData(data.doc)
      })
  }

  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/headandpara/updateheadandpara`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          heading: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const UpdatePara = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/headandpara/updateheadandpara`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          para: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id)
  };

  const ShowParaModal = (id) => {
    setParaModalVisible(true);
    setUpdateId(id)
  };


  const TextHandle = () => {
    if (HeadingUpdate === '') {
      message.error('Fill the Field')
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId
      })
      setTextModalVisible(false);
      setHeadingUpdate('')
    }
  };


  const ParaHandle = () => {
    if (HeadingUpdate === '') {
      message.error('Fill the Field')
    } else {
      UpdatePara({
        text: HeadingUpdate,
        id: UpdateId
      })
      setParaModalVisible(false);
      setHeadingUpdate('')
    }
  };

  const handleCancel = () => {
    setTextModalVisible(false);
    setParaModalVisible(false);
  };


  const OnEnterPress = (event) => {
    const a = HeadingUpdate
    console.log(a)
    if (event.key === 'Enter') {
      console.log('Enter Clicked')
      a.concat('\n')
      setHeadingUpdate(a)
    } else {
      console.log(event.key)
    }
  }



  return (
    <>
      <div className='LDMT-Container'>
        <h2 className='Heading'> 11+ LONG DISTANCE MOVING TIPS </h2>
        <div className='Tips-list'>
          {
            LongDistanceMovingTipsData && LongDistanceMovingTipsData.map(data => (
              <div className='Tip-div'>
                {/* <h3>{data.heading}
                  <i onClick={() => ShowTextModal(data._id)} className="far fa-edit Edit-btn"></i>
                </h3> */}
                <p> {data.para}
                  <i onClick={() => ShowParaModal(data._id)} className="far fa-edit Edit-btn"></i>
                </p>
              </div>
            ))
          }
        </div>

        {/* Update Text Modal */}
        <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
          <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
        </Modal>

        {/* Update Text Modal */}
        <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={ParaModalVisible} onOk={ParaHandle} onCancel={handleCancel} okText="Update" >
          <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Para...' />
        </Modal>

      </div>
    </>
  );
}

export default LocalDistanceMovingTips;
